import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { PHead } from "../components/global/PHead/PHead";
import { useCustomerAnalytics } from "../services/hooks/useCustomerAnalytics";
import { useAppSelector } from "../services/hooks/useReduxHooks";
import { CUSTOMER_ANALYTICS_EVENT, PagesEnum } from "../utils/enums";
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getRestaurantStaticProps } from "../utils/help/staticProps/restaurantStaticProps";
import { getPageLink } from "../utils/help/navigation/navigation";

function Main(props: {
  restaurantInfo: any;
  socialMediaInfo: {
    fbId: string;
    googleTagsManager: string;
    fbDomainVerificationId: string;
    tiktokId: string;
  };
}) {
  const addCustomerAnalytics = useCustomerAnalytics();
  const router = useRouter();
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);

  useEffect(() => {
    if (router.isReady && restaurantInfo) {
      const pageLink = getPageLink(router, PagesEnum.Home);
      router.push(pageLink.href, pageLink.as);
    }
  }, [router.isReady, restaurantInfo?.id]);

  useEffect(() => {
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.ENTERED_WEBSITE, {
      qrcode: router.query.qrcode ? router.query.qrcode.toString() : undefined,
    });
  }, []);

  if (!props.restaurantInfo || !props.socialMediaInfo) {
    return null;
  }

  return (
    <PHead
      restaurantInfo={props.restaurantInfo}
      socialMediaInfo={props.socialMediaInfo}
    />
  );
}

export const getStaticProps = async (context: any) => {
  const { restaurantInfo, socialMediaInfo } = await getRestaurantStaticProps();

  return {
    props: {
      socialMediaInfo,
      restaurantInfo,
      ...(await serverSideTranslations(context.locale, [
        ...globalTranslationFiles,
        "cart",
        "addons",
        "offers",
      ])),
    },
  };
};

Main.displayName = "Main";

export default Main;
